module.exports = __webpack_public_path__ + "static/media/92ec90b2-88be-49c8-8e32-23044cc53818.bceba5c1.JPG";